import { render, staticRenderFns } from "./preMatch.vue?vue&type=template&id=71753452&scoped=true"
import script from "./preMatch.vue?vue&type=script&lang=js"
export * from "./preMatch.vue?vue&type=script&lang=js"
import style0 from "./preMatch.vue?vue&type=style&index=0&id=71753452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71753452",
  null
  
)

export default component.exports